<template>
    <div class="GoodBzzSwitchApariencia">
        <div class="p-4 flex items-center border-none gap-3 top-0 right-0 z-10">
            <label class="block custom-switch cursor-pointer outline-none border-none" for="theme-switch">
                <div class="moon">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="w-[20px] h-[20px] text-gray-500 border-none">
                        <path
                            d="M21 13.9066C19.805 14.6253 18.4055 15.0386 16.9095 15.0386C12.5198 15.0386 8.9612 11.4801 8.9612 7.09034C8.9612 5.59439 9.37447 4.19496 10.0931 3C6.03221 3.91866 3 7.5491 3       11.8878C3 16.9203 7.07968 21 12.1122 21C16.451 21 20.0815 17.9676 21 13.9066Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </div>
                <div class="sun">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                        class="w-[19px] h-[19px] text-offwhite border-none">
                        <path
                            d="M12 23V22M4.22183 19.7782L4.92893 19.0711M1 12H2M4.22183 4.22183L4.92893 4.92893M12 2V1M19.0711 4.92893L19.7782 4.22183M22 12H23M19.0711 19.0711L19.7782 19.7782M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        </path>
                    </svg>
                </div>
                <input type="checkbox" id="theme-switch"
                    class="input absolute translate-x-[1000px] outline-none border-none" v-model="esClaro"
                    @click="alternarApariencia()">
                <div class="slider border-none"></div>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: "GoodBzzSwitchApariencia",

    data() {
        return {
            esClaro: true
        }
    },

    mounted() {
        setTimeout(() => {
            this.aplicarAparienciaConCookie();
        }, 100);
    },

    watch: {
        $route(to) {
            if (to.matched[0].components.default.name === 'NotFound') {
                if (document.documentElement.getAttribute('data-bs-theme') == 'dark') {
                    document.body.style.backgroundImage = `url(${require('@/assets/img/404_fondo_oscuro.webp')})`
                } else {
                    document.body.style.backgroundImage = `url(${require('@/assets/img/404_fondo.webp')})`
                }
            } else {
                document.body.style.backgroundImage = "";
            }
        }
    },

    methods: {
        alternarApariencia() {
            if (localStorage.getItem("cookiesAceptadas") === "true") {
                if (localStorage.getItem("cookiesExperiencia") === "true") {
                    if (document.documentElement.getAttribute('data-bs-theme') == 'dark') document.documentElement.setAttribute('data-bs-theme', 'light')
                    else document.documentElement.setAttribute('data-bs-theme', 'dark')
                    if (document.documentElement.getAttribute('data-bs-theme') == 'dark') {
                        localStorage.setItem("modoOscuro", true);
                    } else {
                        localStorage.setItem("modoOscuro", false);
                    }
                    this.aplicarAparienciaConCookie();
                } else {
                    this.aplicarAparienciaSinCookie();
                }
            } else {
                this.aplicarAparienciaSinCookie();
            }
            /*if (window.location.pathname === '/paneladministrativo/estadisticas/reportesgsst') {
                window.location.reload();
            }*/
        },

        aplicarAparienciaConCookie() {
            setTimeout(() => {
                if (localStorage.getItem("modoOscuro") === "true") {
                    this.esClaro = false;
                    document.documentElement.setAttribute('data-bs-theme', 'dark');
                    this.$store.state.imagenes.defecto.foto = require('@/assets/img/general_foto_perfil_defecto_oscuro.webp');
                    this.$store.state.imagenes.defecto.portada = require('@/assets/img/general_foto_portada_defecto_oscuro.webp');
                    if (this.$router.currentRoute.name === 'NotFound') {
                        document.body.style.backgroundImage = `url(${require('@/assets/img/404_fondo_oscuro.webp')})`
                    }
                } else {
                    this.esClaro = true;
                    document.documentElement.setAttribute('data-bs-theme', 'light');
                    this.$store.state.imagenes.defecto.foto = require('@/assets/img/general_foto_perfil_defecto.webp');
                    this.$store.state.imagenes.defecto.portada = require('@/assets/img/general_foto_portada_defecto.webp');
                    if (this.$router.currentRoute.name === 'NotFound') {
                        document.body.style.backgroundImage = `url(${require('@/assets/img/404_fondo.webp')})`
                    }
                }
            }, 10);
        },

        aplicarAparienciaSinCookie() {
            if (document.documentElement.getAttribute('data-bs-theme') == 'dark') {
                document.documentElement.setAttribute('data-bs-theme', 'light')
                this.$store.state.imagenes.defecto.foto = require('@/assets/img/general_foto_perfil_defecto.webp');
                this.$store.state.imagenes.defecto.portada = require('@/assets/img/general_foto_portada_defecto.webp');
                if (this.$router.currentRoute.name === 'NotFound') {
                    document.body.style.backgroundImage = `url(${require('@/assets/img/404_fondo.webp')})`
                }
            } else {
                document.documentElement.setAttribute('data-bs-theme', 'dark')
                this.$store.state.imagenes.defecto.foto = require('@/assets/img/general_foto_perfil_defecto_oscuro.webp');
                this.$store.state.imagenes.defecto.portada = require('@/assets/img/general_foto_portada_defecto_oscuro.webp');
                if (this.$router.currentRoute.name === 'NotFound') {
                    document.body.style.backgroundImage = `url(${require('@/assets/img/404_fondo_oscuro.webp')})`
                }
            }
        },
    }
}
</script>

<style scoped>
.absolute {
    position: absolute !important;
}

.block {
    display: block !important;
}

.top-0 {
    top: 0 !important;
}

.right-0 {
    right: 0 !important;
}

.z-10 {
    z-index: 10 !important;
}

.flex {
    display: flex !important;
}

.items-center {
    align-items: center !important;
}

.border-none {
    border-style: none !important;
}

.w-\[19px\] {
    width: 19px !important;
}

.w-\[20px\] {
    width: 20px !important;
}

.h-\[19px\] {
    height: 19px !important;
}

.h-\[20\] {
    height: 20px !important;
}

.translate-x-\[1000px\] {
    --tw-translate-x: 1000px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}

.cursor-pointer {
    cursor: pointer !important;
}

.gap-3 {
    gap: .75rem !important;
}

.p-4 {
    padding: 0.75rem !important;
}

.outline-none {
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}

.custom-switch {
    font-size: 17px;
    position: relative;
    display: inline-block;
    width: 60px;
    height: 30px;
    color: #3a3a3a;
}

.custom-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.custom-switch .slider {
    position: absolute;
    cursor: pointer;
    inset: 0;
    background-color: #3a3a3a;
    transition: .4s;
    border-radius: 300px;
}

.custom-switch .slider:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    border-radius: 20px;
    left: 3px;
    bottom: 3px;
    z-index: 2;
    background-color: #212121;
    transition: .4s;
}

.custom-switch .sun svg {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 1;
}

.custom-switch .moon svg {
    position: absolute;
    top: 5px;
    left: 5px;
    z-index: 1;
}

.custom-switch .input:checked+.slider {
    background-color: #cecece;
}

.custom-switch .input:focus+.slider {
    box-shadow: 0 0 1px #cecece;
}

.custom-switch .input:checked+.slider:before {
    transform: translate(29px);
    background: #f2f2f2;
}

.text-gray-500 {
    --tw-text-opacity: 1 !important;
    color: rgb(107 114 128 / var(--tw-text-opacity)) !important;
}

.text-offwhite {
    --tw-text-opacity: 1 !important;
    color: rgb(242 242 242 / var(--tw-text-opacity)) !important;
}
</style>